import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../../components/button/Button";
import { Icon } from "../../../../../components/icon/Icon";
import { useIntlTranslate } from "../../../../../hooks";

import "./ProtectionEditorActions.scss";

interface ProtectionEditorActionsProps {
  onAllowAllClick: () => void;
  onBlockAllClick: () => void;
  blockDisabled: boolean;
  allowDisabled: boolean;
}

export const ProtectionEditorActions = ({
  onAllowAllClick,
  onBlockAllClick,
  blockDisabled,
  allowDisabled,
}: ProtectionEditorActionsProps) => {
  const translate = useIntlTranslate();

  return (
    <div className={"protection-editor-actions"}>
      <Button
        className="protection-editor-actions__button"
        color={"secondary"}
        onClick={onBlockAllClick}
        disabled={blockDisabled}
        aria-label={translate("aria_protection_block_all")}
      >
        <Icon icon="fa-regular fa-ban color-danger" />
        <span>
          <FormattedMessage id="block_all" />
        </span>
      </Button>
      <Button
        className="protection-editor-actions__button"
        color={"secondary"}
        onClick={onAllowAllClick}
        disabled={allowDisabled}
        aria-label={translate("aria_protection_allow_all")}
      >
        <Icon icon="fa-regular fa-check color-success" />
        <span>
          <FormattedMessage id="allow_all" />
        </span>
      </Button>
    </div>
  );
};
